import type { Timestamp } from 'firebase/firestore';

/** "19/10/2026 às 14:32" — `null` enquanto o serverTimestamp ainda não voltou do servidor. */
export function formatarDataHora(timestamp: Timestamp | null | undefined): string {
  if (!timestamp) return 'agora';
  const data = timestamp.toDate();
  const dia = data.toLocaleDateString('pt-BR');
  const hora = data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  return `${dia} às ${hora}`;
}
